import { Stack, Tooltip, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Key } from 'lucide-react'
import { FormattedMessage } from 'react-intl'
import { TaskTypeStyles } from './styles'

export const RevokeTaskComponent: React.FC = () => (
    <Stack direction="row" spacing={1} alignItems="center" sx={TaskTypeStyles.container}>
        <C1Icon icon={Key} sx={TaskTypeStyles.revokeIcon} size="sm" />
        <Typography>
            <FormattedMessage id="task_type_revoke" defaultMessage="Revoke" />
        </Typography>
    </Stack>
)

export const RevokeTaskIcon: React.FC = () => (
    <Tooltip title={<FormattedMessage id="task_type_revoke" defaultMessage="Revoke" />} placement="top">
        <C1Icon icon={Key} sx={TaskTypeStyles.revokeIcon} size="sm" />
    </Tooltip>
)
